import React, { Component, Fragment, useEffect, useState } from 'react';
import { NavMenu } from '../../Controls/NavMenu';

import './Resources/css/site.css';

import Top from './Blocks/Top';
import About from './Blocks/About';
import Footer  from './Blocks/Footer';
import AppWrapper from '../../Controls/Scafolding/AppWrapper';
import Common from '../../Shared/Common';

export class SSDLanding extends Component {

    constructor(props) {
        super(props);
        Common.log('Component Init -> /SSD Landing');

        //let logoImagePath = require("./Resources/Images/logoTransparent.png");
        //let logoIconPath = require("./Resources/Images/logo.ico");

        this.state = {
            brandCode: 'RTech',

            menu: {

                hasLogo: false,
                logoUrl: '', // logoImagePath,
                logoWidth: '250px',

                styles: {},
                insertBars: false,

                text: 'Sanc Souci Dolphins Spearfishing Club',
                //icon: //,logoIconPath,

                items: [
                    { linkLabel: 'about', linkUrl: '#about' },
                    { linkLabel: 'contact', linkUrl: '#contact' },
                    { linkLabel: 'Club Records', linkUrl: '/RecordsLeaderBoard', hardLink : true },
                ],
            }
        };
    }

    render() {
        return (
            <AppWrapper wrapClass="ssd">
                <Top />
                <NavMenu menu={this.state.menu} offset="50" addClass="Menu sticky-top" />
                <Top />

                <About />

                <Footer />
            </AppWrapper>
        );
    }
}

export const SSLSingle = (props) => {

    const [menu, setMenu] = useState({

        hasLogo: false,
        logoUrl: '', // logoImagePath,
        logoWidth: '250px',

        styles: {},
        insertBars: false,

        text: 'Sanc Souci Dolphins Spearfishing Club',
        //icon: //,logoIconPath,

        items: [
            { linkLabel: 'Submit Record', linkUrl: '/SubmitRecord', hardLink:true },
            { linkLabel: 'Club Records', linkUrl: '/RecordsLeaderBoard', hardLink:true },
        ],
    });

    return (

        <AppWrapper wrapClass="ssd">
            <NavMenu menu={menu} offset="50" addClass="Menu sticky-top" />
            {props.children}
            <Footer />
        </AppWrapper>
    );
}



